import script from "./ManageAlertsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageAlertsView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageAlertsView.vue?vue&type=style&index=0&id=564b3d38&lang=scss"

const __exports__ = script;

export default __exports__